import { render, staticRenderFns } from "./InputDocumento.vue?vue&type=template&id=19e2cd48"
import script from "./InputDocumento.vue?vue&type=script&lang=js"
export * from "./InputDocumento.vue?vue&type=script&lang=js"
import style0 from "./InputDocumento.vue?vue&type=style&index=0&id=19e2cd48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports